module.exports = __webpack_public_path__ + "img/poster.b54f1586.jpg";